// import React, { useContext } from "react";
// import { DataContext } from "./DataContext";
// import './Meeting.css';
// import CircularProgress from '@mui/material/CircularProgress';
// import DownloadIcon from '@mui/icons-material/Download';

// const MeetingInfo = () => {
//     const { data, loading, error } = useContext(DataContext);

//     const handleDownload = () => {
//         const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         link.download = "meeting_data.json";
//         link.click();
//         URL.revokeObjectURL(url);
//     };

//     if (loading) {
//         return (
//             <div className="container">
//                 <h2>Loading meeting data...</h2>
//                 <CircularProgress />
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="container">
//                 <h2>Error loading meeting data</h2>
//                 <p>{error}</p>
//             </div>
//         );
//     }

//     if (!data) {
//         return (
//             <div className="container">
//                 <h2>No meeting data available</h2>
//             </div>
//         );
//     }
    
//     return (
//         <div className='container'>
//             <div className='top-bar'>
//                 <button className='download-btn' onClick={handleDownload} style={{ float: 'right' }}>
//                     <DownloadIcon /> Download Data
//                 </button>
//             </div>
//             <div className='header'>
//                 <h1>Meeting Minutes</h1>
//                 <table className='info-table'>
//                     <tbody>
//                         <tr>
//                             <td><strong>Date:</strong></td>
//                             <td>{data.meeting_info.date}</td>
//                         </tr>
//                         <tr>
//                             <td><strong>Time:</strong></td>
//                             <td>{data.meeting_info.start_time} - {data.meeting_info.end_time}</td>
//                         </tr>
//                         <tr>
//                             <td><strong>Duration:</strong></td>
//                             <td>{data.meeting_info.duration}</td>
//                         </tr>
//                         <tr>
//                             <td><strong>Total Participants:</strong></td>
//                             <td>{data.meeting_info.total_participants}</td>
//                         </tr>
//                     </tbody>
//                 </table>
//             </div>
//             <div className='section'>
//                 <h2 className='section-title'>Agenda</h2>
//                 {data.agenda.map((item, index) => (
//                     <div key={index} className='agenda-item'>
//                         <p><strong>Topic:</strong> {item.topic}</p>
//                         <p><strong>Order:</strong> {item.order}</p>
//                         <p><strong>Time Allocation:</strong> {item.time_allocation}</p>
//                         <p><strong>Importance:</strong> {item.importance}</p>
//                         <p><strong>Key Decisions:</strong></p>
//                         <ul>
//                             {item.key_decisions.map((decision, i) => (
//                                 <li key={i}>{decision}</li>
//                             ))}
//                         </ul>
//                         <p><strong>Recurring Themes:</strong></p>
//                         <ul>
//                             {item.recurring_themes.map((theme, i) => (
//                                 <li key={i}>{theme}</li>
//                             ))}
//                         </ul>
//                     </div>
//                 ))}
//             </div>
//             <div className='section'>
//                 <h2 className='section-title'>Discussion Points</h2>
//                 {data.discussion_points.map((point, index) => (
//                     <div key={index}>
//                         <p>
//                             <strong>Topic:</strong> {point.topic}
//                         </p>
//                         <p>
//                             <strong>Key Takeaways:</strong>
//                         </p>
//                         <ul>
//                             {point.key_takeaways.map((takeaway, i) => (
//                                 <li key={i}>{takeaway}</li>
//                             ))}
//                         </ul>
//                         <p>
//                             <strong>Decisions:</strong>
//                         </p>
//                         <ul>
//                             {point.decisions.map((decision, i) => (
//                                 <li key={i}>{decision}</li>
//                             ))}
//                         </ul>
//                         <p>
//                             <strong>Unresolved Questions:</strong>
//                         </p>
//                         <ul>
//                             {point.unresolved_questions.map((question, i) => (
//                                 <li key={i}>{question}</li>
//                             ))}
//                         </ul>
//                         <p>
//                             <strong>Insights:</strong>
//                         </p>
//                         <ul>
//                             {point.insights.map((insight, i) => (
//                                 <li key={i}>{insight}</li>
//                             ))}
//                         </ul>
//                         <p>
//                             <strong>Key Quotes:</strong>
//                         </p>
//                         <ul>
//                             {point.key_quotes.map((quote, i) => (
//                                 <li key={i}>{quote}</li>
//                             ))}
//                         </ul>
//                     </div>
//                 ))}
//             </div>
//             <div className='section'>
//                 <h2 className='section-title'>Action Items</h2>
//                 {data.action_items.map((item, index) => (
//                     <div
//                         className={`action-item ${item.priority.toLowerCase()}-priority`}
//                         key={index}
//                     >
//                         <p>
//                             <strong>Task:</strong> {item.task}
//                         </p>
//                         <p>
//                             <strong>Owner:</strong> {item.owner}
//                         </p>
//                         <p>
//                             <strong>Priority:</strong> {item.priority}
//                         </p>
//                     </div>
//                 ))}
//             </div>
//             <div className='section'>
//                 <h2 className='section-title'>Active Participants</h2>
//                 <table>
//                     <thead>
//                         <tr>
//                             <th>Name</th>
//                             <th>Join Time</th>
//                             <th>Duration</th>
//                             <th>Status</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {data.active_participants.map((participant, index) => (
//                             <tr key={index}>
//                                 <td>{participant.name}</td>
//                                 <td>{participant.join_time}</td>
//                                 <td>{participant.duration}</td>
//                                 <td>{participant.status}</td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//             <div className='section'>
//                 <h2 className='section-title'>Presence Analysis</h2>
//                 <h3>Sentiment Analysis</h3>
//                 {data.presence_analysis.sentiment_analysis.map(
//                     (analysis, index) => (
//                         <div key={index}>
//                             <p>
//                                 <strong>Participant:</strong>{" "}
//                                 {analysis.participant}
//                             </p>
//                             <p>
//                                 <strong>Overall Sentiment:</strong>{" "}
//                                 {analysis.overall_sentiment}
//                             </p>
//                             <p>
//                                 <strong>Sentiment Details:</strong>{" "}
//                                 {analysis.sentiment_details}
//                             </p>
//                             <p>
//                                 <strong>Notable Expressions:</strong>
//                             </p>
//                             <ul>
//                                 {analysis.notable_expressions.map(
//                                     (expression, i) => (
//                                         <li key={i}>{expression}</li>
//                                     )
//                                 )}
//                             </ul>
//                         </div>
//                     )
//                 )}
//                 <h3>Engagement Index</h3>
//                 <table>
//                     <thead>
//                         <tr>
//                             <th>Participant</th>
//                             <th>Score</th>
//                             <th>Speaking Time</th>
//                             <th>Contribution Count</th>
//                             <th>Questions Asked</th>
//                             <th>Topic Introductions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {data.presence_analysis.engagement_index.map(
//                             (engagement, index) => (
//                                 <tr key={index}>
//                                     <td>{engagement.participant}</td>
//                                     <td>{engagement.score}</td>
//                                     <td>{engagement.speaking_time}</td>
//                                     <td>{engagement.contribution_count}</td>
//                                     <td>{engagement.questions_asked}</td>
//                                     <td>{engagement.topic_introductions}</td>
//                                 </tr>
//                             )
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default MeetingInfo;

////////


import React, { useContext, useRef } from "react";
import { DataContext } from "./DataContext";
import './Meeting.css';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const MeetingInfo = () => {
    const { data, loading, error } = useContext(DataContext);
    const meetingContentRef = useRef(null);

    const handleJsonDownload = () => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "meeting_data.json";
        link.click();
        URL.revokeObjectURL(url);
    };

    const handlePdfDownload = async () => {
        if (!meetingContentRef.current) return;
        
        try {
            // Show loading state
            const originalText = document.getElementById("downloadBtn").innerText;
            document.getElementById("downloadBtn").innerText = "Generating PDF...";
            
            // Give time for the UI to update
            await new Promise(resolve => setTimeout(resolve, 100));
            
            const contentElement = meetingContentRef.current;
            const canvas = await html2canvas(contentElement, {
                scale: 2,
                useCORS: true,
                logging: false
            });
            
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });
            
            // Calculate dimensions to fit the content properly
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 295; // A4 height in mm
            const imgHeight = canvas.height * imgWidth / canvas.width;
            
            // Add pages as needed for longer content
            let heightLeft = imgHeight;
            let position = 0;
            
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            
            pdf.save(`Meeting_Minutes_${data.meeting_info.date}.pdf`);
            
            // Reset button text
            document.getElementById("downloadBtn").innerText = originalText;
        } catch (error) {
            console.error("Error generating PDF:", error);
            document.getElementById("downloadBtn").innerText = "Download Failed";
            setTimeout(() => {
                document.getElementById("downloadBtn").innerText = "Download as PDF";
            }, 2000);
        }
    };

    const handleHtmlDownload = () => {
        // Clone the content to avoid modifying the displayed content
        const contentElement = meetingContentRef.current.cloneNode(true);
        
        // Add basic styling to make the downloaded HTML look good
        const styles = `
        <style>
            body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 20px;
                color: #333;
            }
            .container {
                max-width: 1000px;
                margin: 0 auto;
                padding: 20px;
            }
            .section {
                margin-bottom: 30px;
                border-bottom: 1px solid #eee;
                padding-bottom: 20px;
            }
            .section-title {
                color: #2c3e50;
                border-bottom: 2px solid #3498db;
                padding-bottom: 10px;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin: 20px 0;
            }
            th, td {
                border: 1px solid #ddd;
                padding: 8px 12px;
                text-align: left;
            }
            th {
                background-color: #f2f2f2;
            }
            .header h1 {
                color: #2c3e50;
            }
            .info-table {
                width: auto;
            }
            .info-table td {
                padding: 5px 15px 5px 0;
                border: none;
            }
            .action-item {
                margin: 10px 0;
                padding: 15px;
                border-radius: 5px;
            }
            .high-priority {
                background-color: #ffeded;
                border-left: 4px solid #e74c3c;
            }
            .medium-priority {
                background-color: #fff9e6;
                border-left: 4px solid #f39c12;
            }
            .low-priority {
                background-color: #f0f9ff;
                border-left: 4px solid #3498db;
            }
            .agenda-item {
                margin-bottom: 20px;
                padding: 15px;
                background-color: #f9f9f9;
                border-radius: 5px;
            }
        </style>
        `;
        
        const htmlContent = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Meeting Minutes - ${data.meeting_info.date}</title>
            ${styles}
        </head>
        <body>
            ${contentElement.outerHTML}
        </body>
        </html>
        `;
        
        const blob = new Blob([htmlContent], { type: "text/html" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Meeting_Minutes_${data.meeting_info.date}.html`;
        link.click();
        URL.revokeObjectURL(url);
    };

    if (loading) {
        return (
            <div className="container">
                <h2>Loading meeting data...</h2>
                <CircularProgress />
            </div>
        );
    }

    if (error) {
        return (
            <div className="container">
                <h2>Error loading meeting data</h2>
                <p>{error}</p>
            </div>
        );
    }

    if (!data) {
        return (
            <div className="container">
                <h2>No meeting data available</h2>
            </div>
        );
    }
    
    return (
        <div className='container'>
            <div className='top-bar'>
                <div className="download-actions">
                    <button className='download-btn' onClick={handleJsonDownload}>
                        <DownloadIcon /> Download JSON Data
                    </button>
                    <button className='download-btn' onClick={handleHtmlDownload}>
                        <SaveAltIcon /> Download as HTML
                    </button>
                    <button id="downloadBtn" className='download-btn' onClick={handlePdfDownload}>
                        <SaveAltIcon /> Download as PDF
                    </button>
                </div>
            </div>
            <div ref={meetingContentRef}>
                <div className='header'>
                    <h1>Meeting Minutes</h1>
                    <table className='info-table'>
                        <tbody>
                            <tr>
                                <td><strong>Date:</strong></td>
                                <td>{data.meeting_info.date}</td>
                            </tr>
                            <tr>
                                <td><strong>Time:</strong></td>
                                <td>{data.meeting_info.start_time} - {data.meeting_info.end_time}</td>
                            </tr>
                            <tr>
                                <td><strong>Duration:</strong></td>
                                <td>{data.meeting_info.duration}</td>
                            </tr>
                            <tr>
                                <td><strong>Total Participants:</strong></td>
                                <td>{data.meeting_info.total_participants}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='section'>
                    <h2 className='section-title'>Agenda</h2>
                    {data.agenda.map((item, index) => (
                        <div key={index} className='agenda-item'>
                            <p><strong>Topic:</strong> {item.topic}</p>
                            <p><strong>Order:</strong> {item.order}</p>
                            <p><strong>Time Allocation:</strong> {item.time_allocation}</p>
                            <p><strong>Importance:</strong> {item.importance}</p>
                            <p><strong>Key Decisions:</strong></p>
                            <ul>
                                {item.key_decisions.map((decision, i) => (
                                    <li key={i}>{decision}</li>
                                ))}
                            </ul>
                            <p><strong>Recurring Themes:</strong></p>
                            <ul>
                                {item.recurring_themes.map((theme, i) => (
                                    <li key={i}>{theme}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className='section'>
                    <h2 className='section-title'>Discussion Points</h2>
                    {data.discussion_points.map((point, index) => (
                        <div key={index}>
                            <p>
                                <strong>Topic:</strong> {point.topic}
                            </p>
                            <p>
                                <strong>Key Takeaways:</strong>
                            </p>
                            <ul>
                                {point.key_takeaways.map((takeaway, i) => (
                                    <li key={i}>{takeaway}</li>
                                ))}
                            </ul>
                            <p>
                                <strong>Decisions:</strong>
                            </p>
                            <ul>
                                {point.decisions.map((decision, i) => (
                                    <li key={i}>{decision}</li>
                                ))}
                            </ul>
                            <p>
                                <strong>Unresolved Questions:</strong>
                            </p>
                            <ul>
                                {point.unresolved_questions.map((question, i) => (
                                    <li key={i}>{question}</li>
                                ))}
                            </ul>
                            <p>
                                <strong>Insights:</strong>
                            </p>
                            <ul>
                                {point.insights.map((insight, i) => (
                                    <li key={i}>{insight}</li>
                                ))}
                            </ul>
                            <p>
                                <strong>Key Quotes:</strong>
                            </p>
                            <ul>
                                {point.key_quotes.map((quote, i) => (
                                    <li key={i}>{quote}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
                <div className='section'>
                    <h2 className='section-title'>Action Items</h2>
                    {data.action_items.map((item, index) => (
                        <div
                            className={`action-item ${item.priority.toLowerCase()}-priority`}
                            key={index}
                        >
                            <p>
                                <strong>Task:</strong> {item.task}
                            </p>
                            <p>
                                <strong>Owner:</strong> {item.owner}
                            </p>
                            <p>
                                <strong>Priority:</strong> {item.priority}
                            </p>
                        </div>
                    ))}
                </div>
                <div className='section'>
                    <h2 className='section-title'>Active Participants</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Join Time</th>
                                <th>Duration</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.active_participants.map((participant, index) => (
                                <tr key={index}>
                                    <td>{participant.name}</td>
                                    <td>{participant.join_time}</td>
                                    <td>{participant.duration}</td>
                                    <td>{participant.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className='section'>
                    <h2 className='section-title'>Presence Analysis</h2>
                    <h3>Sentiment Analysis</h3>
                    {data.presence_analysis.sentiment_analysis.map(
                        (analysis, index) => (
                            <div key={index}>
                                <p>
                                    <strong>Participant:</strong>{" "}
                                    {analysis.participant}
                                </p>
                                <p>
                                    <strong>Overall Sentiment:</strong>{" "}
                                    {analysis.overall_sentiment}
                                </p>
                                <p>
                                    <strong>Sentiment Details:</strong>{" "}
                                    {analysis.sentiment_details}
                                </p>
                                <p>
                                    <strong>Notable Expressions:</strong>
                                </p>
                                <ul>
                                    {analysis.notable_expressions.map(
                                        (expression, i) => (
                                            <li key={i}>{expression}</li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )
                    )}
                    <h3>Engagement Index (Top 5 Participant)</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Participant</th>
                                <th>Score</th>
                                <th>Speaking Time</th>
                                <th>Contribution Count</th>
                                <th>Questions Asked</th>
                                <th>Topic Introductions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.presence_analysis.engagement_index.map(
                                (engagement, index) => (
                                    <tr key={index}>
                                        <td>{engagement.participant}</td>
                                        <td>{engagement.score}</td>
                                        <td>{engagement.speaking_time}</td>
                                        <td>{engagement.contribution_count}</td>
                                        <td>{engagement.questions_asked}</td>
                                        <td>{engagement.topic_introductions}</td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default MeetingInfo;
